export default function ScrollCue({ label = "Scroll", className = "" }) {
  return (
    <div className={`scroll-cue ${className}`} data-testid="scroll-cue" aria-hidden>
      <span className="scroll-cue-ring"><span className="scroll-cue-dot" /></span>
      <span className="scroll-cue-label">{label}</span>
    </div>
  );
}
